module.exports = __webpack_public_path__ + "img/BAM.a37af98a.svg";